<template>
  <div class="sf__grabber">
    <span />
  </div>
</template>

<style scoped>
  .sf__grabber {
    display: flex;
    justify-content: center;
    padding: 8px;
  }

  .sf__grabber span {
    border-radius: 100px;
    background-color: var(--sf-base-icon-secondary);
    height: 4px;
    width: 36px;
  }
</style>